import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { NapiUser } from "@app/types/napi-types";

import type { Dispatch } from "redux";

import { PassengersApp as PassengersAppComponent } from "./passengers-app";
import { updateUser } from "../../../../../store/state/user";

const mapStateToProps = (state: { user: NapiUser }) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ updateUser }, dispatch);

export const PassengersApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(PassengersAppComponent);
